import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">热门黑料</h2>
          <p className="mt-2 text-sm text-foreground-500">每日精选 · 不容错过</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.map((card, idx) => (
            <article key={idx} className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer transition-all duration-300 hover:-translate-y-1">
              <div className="relative aspect-[4/3] overflow-hidden">
                <img
                  src={card.imageUrl}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={idx > 2 ? 'lazy' : undefined}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-primary-600/90 text-background-50 text-[11px] font-semibold whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="flex items-center gap-1 px-2 py-1 rounded-full bg-background-50/90 text-primary-700 text-[11px] font-semibold whitespace-nowrap">
                    <i className="ri-fire-line text-xs"></i>
                    {card.heat}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 leading-snug line-clamp-2">
                  {card.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-3">
                  {card.excerpt}
                </p>
                <div className="mt-4 flex items-center gap-2 text-xs text-foreground-400">
                  <i className="ri-time-line"></i>
                  <span>今日更新</span>
                  <span className="text-primary-500 font-medium ml-auto whitespace-nowrap">阅读全文 &rarr;</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}